import React from "react";
import { motion } from "framer-motion";
import { Badge } from "./ui/badge";
import { newsData } from "../data/newsData";
import "./news.css";

export const News = () => {
  // Show only the latest 6 news items
  const latestNews = newsData.slice(0, 6);

  return (
    <section id="news" className="news-container py-16 px-4 md:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-center mb-2">
          <Badge variant="secondary" className="text-sm font-medium">
            News
          </Badge>
        </div>
        <h2 className="text-3xl font-bold text-center mb-12">最新のお知らせ</h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestNews.map((news, index) => (
            <motion.div
              key={news.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="border-b border-gray-300 pb-4 mb-4"
            >
              <div className="flex items-center justify-between mb-2">
                <Badge variant="outline" className="text-xs">
                  {news.category}
                </Badge>
                <span className="text-sm text-muted-foreground">
                  {news.date}
                </span>
              </div>
              <h3 className="text-xl font-bold mb-2">{news.title}</h3>
              <p className="text-sm text-gray-600">{news.summary}</p>
              {news.url && (
                <a 
                  href={news.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 text-xs mt-2 inline-block"
                >
                  詳細を見る →
                </a>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
